import React from 'react'
import './style.scss'
import { Icon } from 'react-icons-kit'
import { Modal } from 'react-bootstrap'
import { messageCircle, phoneOutgoing, x } from 'react-icons-kit/feather'

const ContactNumber = (props) => {
    const isCall = props.numberType === 'call'

    return (
        <Modal
            show={props.show}
            onHide={props.onHide}
            dialogClassName="custom-settings-modal sp-modal"
            backdrop="static"
            keyboard={false}
            centered
        >
            <div className="sp-modal-head">
                <span className="sp-modal-icon"><Icon icon={isCall ? phoneOutgoing : messageCircle} size={18} /></span>
                <div className="sp-modal-head-text">
                    <h6>{isCall ? 'Call this member' : 'WhatsApp this member'}</h6>
                    <p>Contact details are unlocked</p>
                </div>
                <button type="button" className="sp-modal-close" onClick={props.onHide} aria-label="Close">
                    <Icon icon={x} size={18} />
                </button>
            </div>

            <div className="sp-modal-body">
                <div className="sp-modal-number">
                    <span>Contact number</span>
                    <h5>{props.number || 'Number not available'}</h5>
                </div>

                {isCall ?
                    <a href={`tel:${props?.number}`} className="sp-modal-btn sp-modal-btn-call sp-modal-btn-block">
                        <Icon icon={phoneOutgoing} size={15} /> Call now
                    </a>
                    :
                    <a
                        href={`https://wa.me/${String(props?.number || '').replace(/[^0-9]/g, '')}`}
                        target="_blank"
                        rel="noreferrer"
                        className="sp-modal-btn sp-modal-btn-wa sp-modal-btn-block"
                    >
                        <Icon icon={messageCircle} size={15} /> WhatsApp now
                    </a>
                }
            </div>
        </Modal>
    )
}

export default ContactNumber
